/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_Label_SpecialInputs */

const nl_validation_password_label_special = /** @type {(inputs: Validation_Password_Label_SpecialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een speciaal teken (bijv. ! of ?)`)
};

/**

* @param {Validation_Password_Label_SpecialInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_label_special = /** @type {((inputs?: Validation_Password_Label_SpecialInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_Label_SpecialInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_label_special(inputs)
});
export { validation_password_label_special as "validation.password.label_special" }